/* RESPONSIBLE TEAM: team-self-serve */
import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import EmberBaseSerializer from 'embercom/serializers/base/embercom-base-serializer';

export default EmberBaseSerializer.extend(EmbeddedRecordsMixin, {
  attrs: {
    levels: { embedded: 'always' },
  },
});
